import { PkiButton, PkiSpinner } from '@software-platforms/design-system-components';
import { UserForm } from '@software-platforms/tenant-manager-ui/models';
import cx from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { UserEntry } from '../user-entry/user-entry';
import styles from './user-create.module.scss';

type OwnProps = {
  form: UserForm;
  isProcessing: boolean;
  onBlur: (controlName: string) => void;
  onChange: (controlName: string, newValue: any) => void;
  onCancel: (event: React.MouseEvent) => void;
  onSendInvite: (event: React.MouseEvent) => void;
};

export const UserCreate: React.FunctionComponent<OwnProps> = (props) => {
  const { form, isProcessing } = props;
  const { t } = useTranslation();

  return (
    <section className={cx('item', 'form', styles.item)}>
      <div className="form-header">
        <div className="form-title">{t('users.form.title')}</div>
        <div className="form-actions">
          <PkiButton
            id="cancel-btn"
            label={t('pki:form.cancel')}
            onClick={props.onCancel}
            size="small"
            variant="secondary"
            disabled={isProcessing}
          />
          <PkiButton
            id="save-btn"
            label={t('users.form.inviteBtnLabel')}
            onClick={props.onSendInvite}
            size="small"
            variant="primary"
            disabled={isProcessing}
            leftIcon={isProcessing && <PkiSpinner size="tiny" />}
          />
        </div>
      </div>
      <UserEntry
        form={form}
        isProcessing={isProcessing}
        onBlur={props.onBlur}
        onChange={props.onChange}
        viewMode="create"
      />
    </section>
  );
};
UserCreate.displayName = 'UserCreate';
